import { render, staticRenderFns } from "./PerformanceViewer.vue?vue&type=template&id=2b189875&scoped=true&"
import script from "./PerformanceViewer.vue?vue&type=script&lang=ts&"
export * from "./PerformanceViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceViewer.vue?vue&type=style&index=0&id=2b189875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b189875",
  null
  
)

export default component.exports